const daysFromToday = days => {
  const today = new Date() // Get the current date
  const millisecondsPerDay = 24 * 60 * 60 * 1000 // Number of milliseconds in a day
  // Calculate the adjustment in milliseconds and
  // Apply the adjustment to the current date

  return new Date(today.getTime() + days * millisecondsPerDay)
}

export default daysFromToday
